


















































import {Component, Mixins, Prop, Watch} from 'vue-property-decorator';
import {LocaleMessage} from 'vue-i18n';

import ErrorAnimation from '../../mixins/ErrorAnimation';

@Component({})
export default class Textarea extends Mixins(ErrorAnimation) {
	@Prop({default: null}) readonly variant?: string | null;
	@Prop({default: false}) readonly disabled?: boolean;
	@Prop({default: () => ([])}) readonly validation?: Array<string>;
	@Prop({default: () => ({})}) readonly onEnter?: Function;
	@Prop({default: null}) readonly suffix?: string | null;
	@Prop() readonly styles?: CSSStyleDeclaration;
	@Prop() readonly classes?: Array<string>;
	@Prop() readonly label?: string;
	@Prop() readonly placeholder?: string;
	@Prop({default: null}) readonly tabIndex?: number;

	$refs: {
		errorMessage: HTMLElement,
		errorPerex: HTMLElement,
	};

	isRequired: boolean = false;
	isValid: boolean | null = null;
	isDirty: boolean = false;
	isFocus: boolean = false;
	validateOnChange: boolean = false;
	value: string = '';
	errorMessage: Array<string | null> = [];
	validationRules: { [key: string]: RegExp } = {
		required: /([^\s])/g
	};
	validationValueRules: { [key: string]: Function } = {
		maxLength: (value: number) => `^(.{${value + 1}})`,
		minLength: (value: number) => `^(?!.{${value},}).*$`
	};

	get errorMessages(): { [key: string]: Function } {
		return {
			required: (): LocaleMessage => this.$t('error.form.required'),
			maxLength: (value: number, fieldValue: string): LocaleMessage => this.$t('error.form.maxLength', {
				current: fieldValue.length,
				limit: value
			}),
			minLength: (value: number): LocaleMessage => this.$t('error.form.minLength', {value})
		};
	};

	get classList(): Array<string | null> {
		return [
			'textarea',
			this.isRequired ? 'textarea--required' : null,
			(this.isValid !== null && !this.isValid) ? 'textarea--error' : null,
			this.isFocus ? 'textarea--focus' : null,
			this.isDirty ? 'textarea--dirty' : null,
			this.disabled ? 'textarea--disabled' : null,
			...(this.classes || [])
		];
	}

	get styleList(): CSSStyleDeclaration | null {
		return this.styles ? {...this.styles} : null;
	}

	@Watch('value')
	onValueChanged(newValue: string | number): void {
		this.handleChange();
		this.$emit('input', newValue);
	}

	created(): void {
		this.$nextTick(() => {
			this.isDirty = this.value.length !== 0;

			this.isRequired = this.validation!.map((rule: string): boolean => {
				return rule === 'required';
			})[0];

		});
	}

	validate() {
		this.isValid = this.validateConditions().every((condition: boolean) => condition);
		return this.isValid;
	}

	validateConditions(): Array<boolean> {
		const validations = this.validation!.map((rule: string): boolean => {
			const [ruleName, ruleValue] = rule.split('|');
			let matched = this.value.match(this.validationRules[ruleName]);
			if (ruleValue) {
				let matched = new RegExp(this.validationValueRules[ruleName](parseInt(ruleValue)), 'g');
				return !this.value.match(matched);
			}
			return !!(matched !== null && matched.length);
		});
		this.errorMessage = validations!.map((valid, validIndex): string | null => {
			if (valid) return null;
			const [ruleName, ruleValue] = this.validation![validIndex].split('|');
			return this.errorMessages[ruleName](ruleValue, this.value);
		}).filter((item) => item !== null);
		return validations;
	}

	handleFocusIn() {
		this.isFocus = true;
	}

	handleFocusOut() {
		this.validateOnChange = this.isDirty;
		this.isFocus = (!!this.value.length && this.isDirty);
		(this.isDirty && this.validation!.length) ? this.validate() : null;
	}

	handleChange() {
		this.isDirty = true;
		this.isFocus = (this.value.length >= 0 && this.isDirty);
		(this.isDirty && this.validateOnChange) ? this.validate() : null;
	}
}
